import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface FactItem {
  fact_id: number;
  fact_url: string | null;
  fact_found_at: string;
  fact_published_at: string;
  fact_status: string;
  fact_category: string;
  fact_relevance_score: number;
  fact_search_source: string | null;
  fact_title: string | null;
  fact_summary: string;
  fact_reasoning: string;
  fact_categorization_model: string;
  fact_age: number | null;
}

export interface GetFactsResponse {
  items: FactItem[];
}

export interface PmaGateway {
  getFacts(): Observable<GetFactsResponse>;
}

export const PMA_GATEWAY = new InjectionToken<PmaGateway>('pma-gateway');
